import { render, staticRenderFns } from "./WebSites.vue?vue&type=template&id=10b02247"
import script from "./WebSites.vue?vue&type=script&lang=js"
export * from "./WebSites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports